//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'

export default {
  name: 'Eckardt',
  data () {
    return {
      form: {
        weightloss: '',
        dysphagia: '',
        pain: '',
        regurgitation: ''
      },
      defaultJson: {
        'Weight Loss (kg)': '体重减少（kg）',
        'Occasional': '偶尔',
        'Retrosternal Pain': '胸骨后疼痛',
        'Dysphagia': '吞咽困难',
        'None': '无',
        'Daily': '每天',
        'Regurgitation': '反流',
        'Each meal': '每餐'
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        {value: '0', name: '∅'},
        {value: '1', name: '≤ 4'},
        {value: '2', name: '5-10'},
        {value: '3', name: '≥ 11'}
      ],
      dataList2: [
        {value: '0', name: '无'},
        {value: '1', name: '偶尔'},
        {value: '2', name: '每天'},
        {value: '3', name: '每餐'}

      ],
      descTxt: ''
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        // weightloss + dysphagia + pain + regurgitation
        let result = form.weightloss + form.dysphagia + form.pain + form.regurgitation
        console.log(result, 'result----------------')
        if (result < 2) {
          self.descTxt = '0级'
        } else if (result > 1 && result < 4) {
          self.descTxt = 'I级'
        } else if (result > 3 && result < 7) {
          self.descTxt = 'II级'
        } else if (result > 6) {
          self.descTxt = 'III级'
        }
        self.hasScore = true
        return String(result)
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/formulas/GIT/Eckardt.vue